import { request } from "../../api/API"
import { multipartRequest } from "../../api/API"

export const updateProfile = (id, params) => {
    return multipartRequest.patch(`/custom_panel/updateProfile/${id}/`, params)
}
